export default "__VITE_ASSET__DihSzsLe__"